document.documentElement.classList.remove('no-js');
(() => {
  const instances = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-header]').forEach(header => {
      if(instances.has(header))return;
      const toggle=header.querySelector('[data-menu-toggle]');
      const menu=header.querySelector('[data-menu]');
      if(!toggle||!menu)return;
      const groups=[...header.querySelectorAll('.pp-menu-group')];
      const events=new AbortController();
      const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal:events.signal});
      const measure=()=>header.style.setProperty('--pp-header-bottom',Math.max(0,header.getBoundingClientRect().bottom)+'px');
      const setOpen=open=>{
        measure();menu.classList.toggle('is-open',open);
        toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Chiudi menu':'Apri menu');
        document.body.classList.toggle('pp-menu-open',open);
        if(!open)groups.forEach(group=>group.open=false);
      };
      const observer=new ResizeObserver(measure);observer.observe(header);
      on(window,'scroll',measure,{passive:true});
      on(toggle,'click',()=>setOpen(!menu.classList.contains('is-open')));
      on(menu,'click',event=>{if(event.target.closest('a'))setOpen(false);});
      groups.forEach(group=>on(group,'toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});}));
      on(header,'keydown',event=>{
        if(event.key==='Escape'){
          const active=groups.find(group=>group.open);
          if(active){active.open=false;active.querySelector('summary').focus();}
          else if(menu.classList.contains('is-open')){setOpen(false);toggle.focus();}
        }
        if(event.key!=='Tab'||!menu.classList.contains('is-open'))return;
        const items=[...header.querySelectorAll('a,button,input:not([type=hidden]),summary')].filter(el=>el.getClientRects().length&&!el.disabled);
        const first=items[0],last=items[items.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
      on(document,'click',event=>{if(!header.contains(event.target))setOpen(false);});
      on(matchMedia('(min-width:990px)'),'change',()=>setOpen(false));
      on(document,'shopify:block:select',event=>{if(header.contains(event.target)){header.closest('.pp-header-shell')?.classList.remove('pp7-header-hidden');if(matchMedia('(max-width:989px)').matches)setOpen(true);const group=event.target.closest('.pp-menu-group');if(group)group.open=true;}});
      measure();instances.set(header,()=>{setOpen(false);observer.disconnect();events.abort();});
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [header,dispose]of instances)if(event.target.contains(header)){dispose();instances.delete(header);}});
})();
